var React = require('react');

function SearchThinInline (props) {
    return React.createElement("svg",props,[React.createElement("circle",{"cx":"8.58125","cy":"8.58125","r":"7.58125","stroke":"currentColor","strokeWidth":"2","key":0}),React.createElement("path",{"d":"M14.1668 14.4333L19.6892 19.6761","stroke":"currentColor","strokeWidth":"2","key":1})]);
}

SearchThinInline.defaultProps = {"width":"21","height":"21","viewBox":"0 0 21 21","fill":"none"};

module.exports = SearchThinInline;

SearchThinInline.default = SearchThinInline;
